import { render } from "./PokemonInfoTemplate.vue?vue&type=template&id=b2a6e7de&scoped=true"
import script from "./PokemonInfoTemplate.vue?vue&type=script&lang=ts"
export * from "./PokemonInfoTemplate.vue?vue&type=script&lang=ts"

import "./PokemonInfoTemplate.vue?vue&type=style&index=0&id=b2a6e7de&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b2a6e7de"

export default script